import { isiOS } from '@/kits/system';

interface HttpClient {
  post: (
    url: string,
    params: { jumpAppId: string; os: 'ios' | 'android' }
  ) => Promise<{ data?: { jumpAppMaxVc?: string | number } }>;
}

export const getJumpAppVersion = async (http: HttpClient, jumpAppId: string): Promise<string> => {
  try {
    const apiPrefix = process.env.NODE_ENV === 'production' ? '' : '/api';
    const response = await http.post(`${apiPrefix}/dxapp/jumpapp/info`, {
      jumpAppId,
      os: isiOS ? 'ios' : 'android'
    });
    const version = response.data?.jumpAppMaxVc;
    return version ? String(version) : '';
  } catch (error) {
    return '';
  }
};
